// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ImageText-module--wrapper--3ZgpP","cover_image":"ImageText-module--cover_image--3NL1J","supplier":"ImageText-module--supplier--1Xcad"};